var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Update Organization Association",
        "header-bg-variant": "success",
        "header-text-variant": "light",
        size: "lg",
        visible: _vm.showModal,
        centered: ""
      },
      on: { hidden: _vm.reset },
      scopedSlots: _vm._u([
        {
          key: "modal-header-close",
          fn: function() {
            return [_c("h4", [_vm._v("X")])]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "h2",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.updateUserMembershipPending,
                  expression: "updateUserMembershipPending"
                }
              ],
              staticClass: "u-padding-bottom-20"
            },
            [_vm._v("Updating, please wait ...")]
          ),
          _vm._v(" "),
          _c("pulse-loader", {
            attrs: {
              loading: _vm.updateUserMembershipPending,
              color: "#0F347B",
              size: "50px"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.updateUserMembershipPending
        ? _c(
            "b-row",
            [
              _c("b-col", [
                _vm._v(
                  "      \n      Modifying or removing organizations from Group Membership is not currently a feature.  \n      "
                ),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v("\n      If you would like to change "),
                _c("b", [_vm._v(_vm._s(_vm.orgName))]),
                _vm._v(" association with "),
                _c("b", [_vm._v(_vm._s(_vm.selectedGroup.groupName))]),
                _vm._v(
                  " , then please let the system administrator know.\n    "
                )
              ]),
              _vm._v(" "),
              _c("b-col", [
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("Created At: ")]),
                _vm._v("  " + _vm._s(_vm.getCreatedAt()) + "\n      "),
                _vm._.isObject(_vm.selectedGroup.createdBy)
                  ? _c("div", [
                      _c("b", [_vm._v(" by: ")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._.get(
                              _vm.selectedGroup,
                              "createdBy.emailAddress",
                              ""
                            )
                          ) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("Last Updated: ")]),
                _vm._v(" " + _vm._s(_vm.getLastUpdateDate()) + "\n      "),
                _vm._.isObject(_vm.selectedGroup.updatedBy)
                  ? _c("div", [
                      _c("b", [_vm._v(" by: ")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._.get(
                              _vm.selectedGroup,
                              "updatedBy.emailAddress",
                              ""
                            )
                          ) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("br")
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          attrs: {
            dismissible: "",
            fade: "",
            show:
              _vm.updateUserMembershipFailure ||
              _vm._.isObject(_vm.updateUserMembershipSuccess),
            variant: _vm.updateUserMembershipFailure ? "danger" : "success"
          }
        },
        [
          _c("span", {
            domProps: { innerHTML: _vm._s(_vm.apiResponseMessage()) }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { slot: "modal-footer" },
          slot: "modal-footer"
        },
        [
          _c("span", { staticClass: "text-danger" }, [
            _vm._v(
              " Please contact the system admin to modify group membership.  "
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43b00972", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43b00972","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/DeleteGroupOrgMembershipModal.vue
// module id = 1915
// module chunks = 0